export default __webpack_public_path__ + "static/media/brushfire-label.038ea8a4.png";